import React, { useContext } from "react";
import TextField from "@material-ui/core/TextField";
import Autocomplete from "@material-ui/lab/Autocomplete";
import { Fragment } from "react";
import ValidationMessage from "../../../services/ValidationMessage";
import { ValidationContext } from "../../../services/FormValidator";
// import { BROWSER_TYPES, detectBrowserType, ENUMS } from "../../../constants";
import { ENUMS } from "../../../constants";

import { makeStyles } from "@material-ui/core/styles";

export default function CustomAutoComplete(props) {
  const useStyles = makeStyles(() => ({
    noCloseButton: {
      "& .MuiAutocomplete-clearIndicator": {
        display: "none",
      },
    },
  }));
  const classes = useStyles();

  const { autoCompleteProps, textFieldProps } = props;
  let {
    allowAllOption,
    options,
    allOptionField,
    oneSelectionAllowedOnly,
    dynamicallySetOptionLabel,
    value,
  } = autoCompleteProps;
  const contextValid = useContext(ValidationContext);

  //If select all is allowed and options has data, add All option.
  if (allowAllOption && options.length) {
    autoCompleteProps.options = [
      {
        [allOptionField]: ENUMS.ALL_DROPDOWN_OPTION.TEXT,
        id: ENUMS.ALL_DROPDOWN_OPTION.ID,
      },
      ...options,
    ];
  }

  //If value is an array of unique number values only, then set value as json of dynamic label and unique key
  if (
    dynamicallySetOptionLabel &&
    options.length &&
    value.length &&
    typeof value[0] === "number"
  ) {
    autoCompleteProps.value = autoCompleteProps.value.map((id) => {
      return {
        [dynamicallySetOptionLabel]: options.getElementByParam("id", id)[
          [dynamicallySetOptionLabel]
        ],
        id,
      };
    });

    autoCompleteProps.dynamicOptionLabelOnChange(null, autoCompleteProps.value);
  }

  //Checks if user has selected All in any case
  let isUserSelectedAll = (data) => {
    return data.some((ele) => ele.id === ENUMS.ALL_DROPDOWN_OPTION.ID);
  };

  //Handle changes whenever user selects All option or deselects it.
  let allChangeHandler = (ev, value) => {
    let { onChange } = autoCompleteProps;

    if (
      isUserSelectedAll(value) &&
      value[value.length - 1].id === ENUMS.ALL_DROPDOWN_OPTION.ID
    ) {
      return onChange(
        ev,
        value.filter((ele) => ele.id === ENUMS.ALL_DROPDOWN_OPTION.ID)
      );
    } else if (
      isUserSelectedAll(value) &&
      value[value.length - 1].id !== ENUMS.ALL_DROPDOWN_OPTION.ID
    ) {
      return onChange(
        ev,
        value.filter((ele) => ele.id !== ENUMS.ALL_DROPDOWN_OPTION.ID)
      );
    } else {
      onChange(ev, value);
    }
  };

  let allOptionsHandler = () => {
    autoCompleteProps.options = autoCompleteProps.options.filter((ele) => {
      let bool = true;
      autoCompleteProps.value.forEach((Element) => {
        if (Element.id === ele.id) {
          bool = false;
        }
      });
      return bool;
    });
    return autoCompleteProps.options;
  };

  return (
    <Fragment>
      <Autocomplete
        {...autoCompleteProps}
        options={
          oneSelectionAllowedOnly
            ? allOptionsHandler()
            : autoCompleteProps.options
        }
        onChange={
          allowAllOption ? allChangeHandler : autoCompleteProps.onChange
        }
        renderInput={(params) => (
          <TextField
            {...params}
            {...textFieldProps}
            inputProps={{
              ...params.inputProps,

              autoComplete: "ERP-disabled",
            }}
          />
        )}
        className={props.hideCrossBtn ? classes.noCloseButton : ""}
      />
      {contextValid &&
      contextValid.errors &&
      contextValid.errors[autoCompleteProps.name] ? (
        <ValidationMessage
          errorMessage={props.errorMessage}
          name={autoCompleteProps.name}
        />
      ) : (
        <span className="text-danger error-msg">{props.errorMessage}</span>
      )}
    </Fragment>
  );
}
